import React from 'react';
import HeroContent from './hero/HeroContent';
import HeroBackground from './hero/HeroBackground';

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center overflow-hidden" id="home">
      <HeroBackground />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <HeroContent />
      </div>
    </div>
  );
};

export default Hero;